import Modal from './Modal';

export default class UserProfile {
  constructor() {
    new Modal();
  }
}
